import sanitizeHtml from 'sanitize-html';
export var sanitize = function (content) {
    return sanitizeHtml(content + '');
};
